var map = {
	"./Chef-restaurant-logo-illustrations-template-on-transparent-background-PNG.png": 1821,
	"./Screenshot 2024-06-04 at 6.23.56 PM.png": 6065,
	"./agneslogo.png": 2252,
	"./asalogo.png": 5171,
	"./bell-icon.png": 7929,
	"./birdieslogo.png": 7439,
	"./campaign.png": 8263,
	"./chat-2.png": 4240,
	"./chat.png": 652,
	"./delete-icon.png": 2464,
	"./esterslogo.png": 4869,
	"./info.png": 9548,
	"./lapuglialogo.png": 2081,
	"./left-arrow.png": 4238,
	"./logout.png": 6645,
	"./milologo.png": 5801,
	"./osealogo.png": 286,
	"./popoverslogo.png": 9116,
	"./profile.png": 4254,
	"./referral-2.png": 4934,
	"./referral-3.png": 6150,
	"./referral-4.png": 717,
	"./referral.png": 6705,
	"./report-2.png": 8476,
	"./report.png": 1799,
	"./reservation-icon.png": 323,
	"./right-arrow.png": 7898,
	"./staginglogo.png": 2574,
	"./star-icon.png": 3592,
	"./superherologo.png": 9093,
	"./tarandroseslogo.png": 2477,
	"./tesselogo-2.png": 8317,
	"./tesselogo.png": 5346,
	"./users.png": 1961,
	"./wallys-bhlogo.png": 8971,
	"./wallys-lvlogo.png": 1037,
	"./wallys-smlogo.png": 7891,
	"./zozologo.png": 2523
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;